export default {
  "member": "Miembro del personal",
  "avatar": "Avatar del personal",
  "viewAvatar": "Ver el avatar de {name}",
  "search": "Buscar personal por nombre o correo electrónico",
  "allStatuses": "Todos los estados",
  "allRoles": "Todos los puestos",
  "name": "Nombre",
  "role": "Puesto",
  "status": "Estado",
  "certifications": "Certificaciones",
  "joined": "Incorporación",
  "joinedDate": "Incorporación: {date}",
  "actions": "Acciones",
  "grid": "Vista de tarjetas",
  "list": "Vista de lista",
  "active": "Activo",
  "inactive": "Inactivo",
  "call": "Llamar al miembro del personal",
  "message": "Enviar un mensaje al miembro del personal",
  "noExtension": "Sin extensión asignada",
  "noExtensionBody": "Este miembro del personal no tiene una extensión telefónica asignada.",
  "callFailed": "No se puede abrir el marcador",
  "conversationFailed": "No se puede abrir la conversación",
  "profileMissing": "No hemos podido identificar tu perfil de personal para la mensajería.",
  "selfMessage": "No puedes enviarte mensajes a ti mismo",
  "selectOther": "Selecciona a otro miembro del personal.",
  "retry": "Inténtalo de nuevo.",
  "loadError": "No se puede cargar el personal. Inténtalo de nuevo.",
  "restricted": "No tienes acceso a estos registros de personal.",
  "empty": "No se ha encontrado personal",
  "emptyHelp": "Prueba a ajustar los filtros o los términos de búsqueda.",
  "loading": "Cargando personal…",
  "oneResult": "{count} miembro del personal",
  "manyResults": "{count} miembros del personal",
  "clear": "Borrar filtros",
  "noCertifications": "Sin certificaciones",
  "noReports": "Sin subordinados directos",
  "noManager": "Sin responsable asignado",
  "noMatches": "No se ha encontrado personal coincidente",
  "select": "Seleccionar a {name}",
  "certificationExpired": "{name} · Venció el {date}"
}
